
import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { StaffManagement } from "./staff/StaffManagement";
import { PatientFileManagement } from "./PatientFileManagement";
import { InventoryManagement } from "./inventory/InventoryManagement";

interface ManagementDashboardProps {
  initialTab?: string;
}

export function ManagementDashboard({ initialTab = "patient-files" }: ManagementDashboardProps) {
  const [activeTab, setActiveTab] = useState(initialTab);

  return (
    <div className="p-4 space-y-6">
      <h1 className="text-2xl font-bold">Gestion professionnelle</h1>
      
      <Tabs 
        defaultValue={initialTab}
        value={activeTab}
        onValueChange={setActiveTab}
        className="w-full"
      >
        <TabsList className="grid grid-cols-3 w-full">
          <TabsTrigger value="patient-files">Dossiers patients</TabsTrigger>
          <TabsTrigger value="staff">Personnel</TabsTrigger>
          <TabsTrigger value="inventory">Inventaire</TabsTrigger>
        </TabsList>
        
        <TabsContent value="patient-files" className="mt-6">
          <PatientFileManagement />
        </TabsContent>
        
        <TabsContent value="staff" className="mt-6">
          <StaffManagement />
        </TabsContent>
        
        <TabsContent value="inventory" className="mt-6">
          <InventoryManagement />
        </TabsContent>
      </Tabs>
    </div>
  );
}
